import { useState } from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import HighlightCard from '../components/sections/HighlightCard'; // Reuse our beautiful card component

export default function SearchPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [hasSearched, setHasSearched] = useState(false); // Track if a search has been performed

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchTerm.trim()) {
        return; // Don't search for empty strings
    }
    
    setLoading(true);
    setError('');
    setHasSearched(true);
    setResults([]);

    try {
      // Use URLSearchParams to safely encode the search term
      const params = new URLSearchParams({ q: searchTerm });
      const response = await fetch(`${process.env.REACT_APP_API_URL}/campaigns/search?${params}`);
      
      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.message || 'Search failed.');
      }
      const data = await response.json();
      setResults(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-900 py-16 min-h-[70vh]">
      <div className="container mx-auto px-4 text-center max-w-4xl">
        <h1 className="text-4xl font-black uppercase text-gray-800 dark:text-white tracking-widest">
          Search Campaigns
        </h1>
        <p className="mt-2 text-lg text-gray-500 dark:text-gray-400">
          Find a specific campaign by the name of the product being requested.
        </p>

        <form onSubmit={handleSearch} className="mt-8 relative">
          <input
            type="search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="e.g., Braille, Reader, Cane..."
            className="w-full py-4 pl-6 pr-14 text-lg bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 rounded-full focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
            autoFocus
          />
          <button
            type="submit"
            className="absolute right-3 top-1/2 -translate-y-1/2 p-2 text-gray-500 hover:text-orange-500 transition-colors"
            aria-label="Search"
          >
            <MagnifyingGlassIcon className="h-7 w-7" />
          </button>
        </form>

        {/* --- DYNAMIC RESULTS SECTION --- */}
        <div className="mt-12 text-left">
            {loading && <p className="text-center text-lg">Searching...</p>}
            {error && <p className="text-center text-lg text-red-500">{error}</p>}
            
            {hasSearched && !loading && results.length === 0 && (
                <p className="text-center text-lg text-gray-500">No campaigns found matching your search.</p>
            )}

            {results.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {results.map(campaign => (
                        <HighlightCard key={campaign.id} highlight={campaign} />
                    ))}
                </div>
            )}
        </div>
      </div>
    </div>
  );
}